/**
 * Tabla del panel partida en "Esta semana" / "Histórico" (Sol 16/09: como en
 * Altas y Bajas, visualmente más ordenado). La semana es lunes–domingo en
 * Buenos Aires y se compara por fecha de ingreso (string date-only, shared/dates).
 */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { formatDayMonth, getCurrentWeekRangeAR, isoDateInRange } from '@/../../shared/dates';
import { AltasTable } from './AltasTable';
import type { RowWithSteps } from './usePeopleFlowRows';

export function WeekSplitTable({ rows, allRows, emptyText, lastRunAt }: {
  rows: RowWithSteps[];
  allRows: RowWithSteps[];
  emptyText: string;
  lastRunAt?: string | null;
}) {
  const { t } = useTranslation();
  const weekRange = useMemo(() => getCurrentWeekRangeAR(), []);
  const thisWeek = useMemo(() => rows.filter((r) => isoDateInRange(r.row.alta.fechaIngresoParsed, weekRange)), [rows, weekRange]);
  const history = useMemo(() => rows.filter((r) => !isoDateInRange(r.row.alta.fechaIngresoParsed, weekRange)), [rows, weekRange]);
  const count = (n: number) => <span className="ml-1.5 rounded-full bg-muted-foreground/15 px-1.5 text-xs tabular-nums">{n}</span>;

  return (
    <Tabs defaultValue={thisWeek.length > 0 ? 'week' : 'history'}>
      <TabsList>
        <TabsTrigger value="week">{t('users.week_tabs.this_week')}{count(thisWeek.length)}</TabsTrigger>
        <TabsTrigger value="history">{t('users.people_panel.week.history', 'Histórico')}{count(history.length)}</TabsTrigger>
      </TabsList>
      <TabsContent value="week" className="mt-4 space-y-3">
        <p className="text-sm text-muted-foreground">
          {t('users.week_tabs.week_of', { start: formatDayMonth(weekRange.weekStart), end: formatDayMonth(weekRange.weekEnd) })}
        </p>
        <AltasTable rows={thisWeek} allRows={allRows} emptyText={t('users.people_panel.week.empty_week', 'Sin ingresos esta semana en este cajón.')} lastRunAt={lastRunAt} />
      </TabsContent>
      <TabsContent value="history" className="mt-4">
        <AltasTable rows={history} allRows={allRows} emptyText={emptyText} lastRunAt={lastRunAt} />
      </TabsContent>
    </Tabs>
  );
}
